import './App.css';
import AppRouter from './router/AppRouter';
import ConfigError from './components/ConfigError';
import { configErrors } from './config/config';

function App() {
  // A misconfigured build must fail visibly here rather than render an app
  // whose every request 404s against its own origin.
  if (configErrors.length) return <ConfigError errors={configErrors} />;

  return <AppRouter />;
}

export default App;
